import { CHANGE_EMAIL } from 'analytics/constants/ids';

import { trackScreenLoad, trackClick } from 'services/Analytics';

export const trackChangeEmailPageLoad = () => trackScreenLoad(CHANGE_EMAIL);

export const trackChangeEmailSave = () => trackClick(CHANGE_EMAIL, { event_action: 'save' });
